import {useQuery} from "react-query";
import {useParams} from "react-router-dom";
import {SsoService} from "../../../services/SsoService";
import {logErrorToSentry} from "../../../utils/sentry";

export const useSsoConfigurationQuery = (options?: {enabled?: boolean}) => {
  const {organizationId} = useParams<{organizationId: string}>();

  return useQuery(
    ["ssoConfiguration", organizationId],
    async () => {
      const {data} = await SsoService.getConfiguration(organizationId);
      return data;
    },
    {
      onError: err => {
        logErrorToSentry(err);
      },
      enabled: !!organizationId,
      ...options,
    },
  );
};
